import React from "react";
import { Box, Button, Stack, Typography } from "@mui/material";

const GoogleLoginMessage = ({ zoomLogin, onLater }) => {
    return (
        <Box
            sx={{
                display: "flex",
                flexDirection: "column",
                alignItems: "center", // Centers the inner box horizontally
                justifyContent: "space-between", // Centers the inner box vertically
                height: "100%", // Takes full height of the container
                p: 4,
                border: ": 1px solid blue",
            }}
        >
            <Stack>
                <Typography
                    sx={{
                        fontWeight: "500",
                        color: "#1C2024",
                    }}
                >
                    Success! Your Google Calendar is Connected
                </Typography>
                <Typography
                    sx={{
                        opacity: 0.7,
                        color: "#595959",
                    }}
                >
                    You can now see upcoming events.
                </Typography>
                <Typography
                    sx={{
                        fontWeight: "500",
                        color: "#1C2024",
                        pt: 2, // Padding bottom
                    }}
                >
                    Next Step: Connect Zoom
                </Typography>
                <Typography
                    sx={{
                        opacity: 0.7,
                        color: "#595959",
                    }}
                >
                    This will automatically import selected recordings and
                    transcribe, and analyze them.
                </Typography>
            </Stack>
            <Stack
                direction="row"
                alignItems="flex-end"
                justifyContent={"flex-end"}
                spacing={2}
                sx={{
                    width: "100%",
                    pt: 2, // Padding top
                }}
            >
                <Button
                    onClick={onLater}
                    sx={{
                        bgcolor: "rgba(0, 9, 59, 0.05)",
                        color: "#60646C",
                        fontSize: 12,
                        mr: 1, // Margin right for spacing between buttons
                        textTransform: "none", // Keeps the text case as is
                    }}
                >
                    Later
                </Button>
                <Button
                    onClick={zoomLogin}
                    sx={{
                        bgcolor: "primary.main", // Use your theme's primary color
                        color: "white",
                        "&:hover": {
                            bgcolor: "primary.dark", // Darken the color when hovered
                        },
                    }}
                    variant="contained"
                >
                    Connect Zoom
                </Button>
            </Stack>
        </Box>
    );
};

export default GoogleLoginMessage;
